export const formNames = [
  "romp-competition",
  "mua-competition"
];
